<template>
  <div class="modify-tel">
    <div class="page-width">
      <div class="tel-title">
        <router-link to="/personal/account">
          <h3>个人中心</h3>
        </router-link>
        <span>&nbsp;&nbsp;/&nbsp;&nbsp;修改手机号</span>
      </div>
      <div class="tel-content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "app"
};
</script>

<style lang="scss" scoped>
.router-link-exact-active {
  color: #4272ab;
}
.modify-tel {
  background-color: #f8f8f8;
  width: 100%;
  height: calc(100vh - 60px);
}
.page-width {
  width: 1200px;
  margin: 20px auto;
}
.tel-title {
  padding: 10px 0 20px 0px;
  display: table-cell;
  vertical-align: bottom;
  h3 {
    display: inline-block;
  }
  span {
    color: #666;
  }
}
.tel-content {
  box-shadow: 0px 1px 4px 0px rgba(176, 176, 176, 0.36);
  height: 520px;
  background-color: #fff;
}
</style>
